---
id: resume-service-go
title: Resume service
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - resume
  - parsing
  - microservice
---

## Product Overview

### Who it serves

This microservice supports resume workflows including parsing uploads, retrieving resume data, and managing resume lifecycle operations.

### Primary workflow

Authenticated clients upload resumes for parsing, request review plans or spell checks, and manage resume records such as transfer and deletion.

### Business rules

Most endpoints require Firebase authentication, enterprise read endpoints are unauthenticated, and deletion enforces user ownership before removing resumes.

### Outcomes

Parsed resume content, review data, and updated resume records are persisted for use in downstream resume builder and review experiences.

### Out of scope

Frontend presentation, subscription enforcement, and analytics are handled by other services.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/resume-service-go-api-docs)

## Technical Overview

### Architecture flow

Routes in `apps/micro-services/resume-service-go/pkg/api/routes/routes.go` assemble controllers for parsing, review plans, resume management, and MCP updates.

### Entry points

- Key handlers include `Parser.PostParseResumeHandler`, `Review.GetResumeReviewPlans`, and `Resume` controller methods under `apps/micro-services/resume-service-go/pkg/api/controllers`.
- A standalone data migration binary lives at `apps/micro-services/resume-service-go/cmd/linkedin-transformator/main.go` for normalizing LinkedIn URL fields in stored resumes.
- The OpenAPI generator entry point is `apps/micro-services/resume-service-go/cmd/spec/main.go`, which builds `spec.json` from the route definitions.

### Key modules

Parsing logic lives in `apps/micro-services/resume-service-go/pkg/services/parsers`, review logic in `apps/micro-services/resume-service-go/pkg/services`, and resume transfer logic in `apps/micro-services/resume-service-go/pkg/services/transfers`.

### Data sources and sinks

Firestore repositories store resume data, and file uploads are persisted to GCS through the storage adapters in `apps/micro-services/resume-service-go/pkg/repo/storage`.

### Integrations and side effects

The service integrates with Firebase, GCS, GPT-based callers, and spellchecking adapters, and it can clean up AI interview data when resumes are deleted.

### Constraints and risks

Parsing and spellcheck depend on external AI services and cloud storage configuration, and startup requires multiple credentials to be configured correctly.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Noted the OpenAPI spec generator entry point.
- 2026-01-30: Documented the LinkedIn transformator migration binary.
- 2026-01-30: Initial documentation.
